export default {
  name: 'logo',
  props: {
    color: {
      default: 'dark',
      type: String
    }
  }
}